import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useFormikContext } from 'formik';
import lodashGet from 'lodash/get';
import { memo, useCallback } from 'react';
import { FaPlus, FaRegTrashAlt } from 'react-icons/fa';
import { Multiplets } from '../../../../../data/constants/Multiplets';
import Button from '../../../../elements/Button';
import FormikInput from '../../../../elements/formik/FormikInput';
import FormikSelect from '../../../../elements/formik/FormikSelect';
import { hasCouplingConstant, translateMultiplet, } from '../../../../panels/extra/utilities/MultiplicityUtilities';
const CouplingsTableStyle = css `
  border-spacing: 0;
  border: 1px solid #dedede;
  width: 100%;
  height: 100%;
  font-size: 12px;

  th,
  td {
    text-align: center;
    margin: 0;
    padding: 0.3rem;
    border-bottom: 1px solid #f5f5f5;

    .select-box {
      background-color: transparent;
      border: 0.5px solid #dedede;
      height: 100%;
      width: 100% !important;
      text-align: center;
      margin: 0;
    }
  }
`;
function CouplingsTable({ push, remove, onFocus, onBlur, }) {
    const { values, setFieldValue } = useFormikContext();
    const multiplicityChangeHandler = useCallback((value, name) => {
        if (!hasCouplingConstant(value)) {
            setFieldValue(name, '');
        }
    }, [setFieldValue]);
    const couplingsList = lodashGet(values, `signals[${values.activeTab}].js`, []);
    return (_jsxs("div", { children: [_jsxs(Button.Done, { fill: "outline", style: { marginBottom: '10px' }, onClick: () => push({
                    multiplicity: translateMultiplet('m'),
                    coupling: '',
                }), children: [_jsx(FaPlus, { title: "Add new coupling", style: { display: 'inline-block' } }), _jsx("span", { style: { display: 'inline-block', paddingLeft: '5px' }, children: "Add New Coupling" })] }), _jsx("table", { css: CouplingsTableStyle, children: _jsxs("tbody", { children: [_jsxs("tr", { children: [_jsx("th", { children: "#" }), _jsx("th", { children: "Multiplicity" }), _jsx("th", { children: "J (Hz)" }), _jsx("th", { children: '' })] }), couplingsList.map((_coupling, i) => (_jsxs("tr", { children: [_jsx("td", { children: i + 1 }), _jsx("td", { children: _jsx(FormikSelect, { className: "select-box", name: `signals.${values.activeTab}.js.${i}.multiplicity`, items: Multiplets, itemValueField: "label", onChange: (value) => {
                                            multiplicityChangeHandler(value, `signals.${values.activeTab}.js.${i}.coupling`);
                                        } }) }), _jsx("td", { children: _jsx(FormikInput, { name: `signals.${values.activeTab}.js.${i}.coupling`, type: "number", placeholder: 'J (Hz)', disabled: !hasCouplingConstant(_coupling.multiplicity), onFocus: onFocus, onBlur: onBlur, style: {
                                            input: {
                                                width: '100%',
                                                height: '26px',
                                            },
                                        }, checkErrorAfterInputTouched: false }) }), _jsx("td", { children: _jsx("div", { style: { display: 'flex' }, children: _jsx(Button.Danger, { fill: "clear", onClick: () => {
                                                remove(i);
                                            }, children: _jsx(FaRegTrashAlt, { title: "Delete coupling" }) }) }) })] }, `editCouplings${values.activeTab}${i}`)))] }) })] }));
}
export default memo(CouplingsTable);
